import { ThunkType } from "../../../../core/store/reducers";
import { getGuaranteesReport } from "../api/getGuaranteesReport";
import fileDownload from "js-file-download";
import { setFetchState } from "../guaranteesDataSlice";

export const downloadGuaranteesReport = (): ThunkType => async (
  dispatch,
  getStore
) => {
  const store = getStore();

  if (store.data.auth.current.status !== "successful") {
    return undefined;
  }

  const { filter } = store.ux.clearing.guarantees;
  const user = store.data.auth.current.user;

  dispatch(setFetchState({ type: "started" }));
  const ordersReport = await dispatch(getGuaranteesReport(user, filter));
  if (ordersReport) {
    fileDownload(
      new Blob([ordersReport as any], { type: "application/pdf" }),
      "Guarantees.pdf"
    );
  }
  dispatch(setFetchState({ type: "not-started" }));
};

